export const environment = {
  production: true,
  rootUrl: 'https://www.xn--hq1b31kn1k98b.com',
  s3: {
    bucketname: 'dowa-lighting-homepage',
  },
};
